// extracted by mini-css-extract-plugin
export default {"button":"ParticipatedEvent_button__m94qD","error":"ParticipatedEvent_error__fODAW"};